import { render, staticRenderFns } from "./SalesOrder.vue?vue&type=template&id=a54e0f10&scoped=true"
import script from "./SalesOrder.vue?vue&type=script&lang=js"
export * from "./SalesOrder.vue?vue&type=script&lang=js"
import style0 from "./SalesOrder.vue?vue&type=style&index=0&id=a54e0f10&prod&scoped=true&lang=css"
import style1 from "./SalesOrder.vue?vue&type=style&index=1&id=a54e0f10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54e0f10",
  null
  
)

export default component.exports